"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxItemsNumber = exports.algoliaDomains = void 0;
const algoliaDomains = exports.algoliaDomains = ['algolia.net', 'algolianet.com', 'algolia.com'];
const maxItemsNumber = exports.maxItemsNumber = 20;